<template>
  <div class="idea">
    <div class="content">
      <div class="tips">CEPPEA标准征求意见稿起草完成后，协会组织向涉及本标准内容的利益相关方以信函方式征求意见。</div>
      <div class="tips">征求意见一般不少于30日。被征求意见的单位或个人应当在规定日期前回复意见，对所有意见，应当说明依据或理由；逾期不回复的，视为无异议。</div>
    </div>
    <a-button @click.native.stop="submit">查看更多</a-button>
  </div>
</template>

<script>
export default {
  methods: {
    submit() {
      // window.open(`${this.$FN.publicUrl}/npg/stdcompile/suggestion`)
      // this.$router.$push({ path: "container", query: { url: `${this.$FN.iframeUrl}/npg/stdcompile/suggestion` } })
      if (this.$FN.getUser()) {
        this.$FN.limitsTips({ list: ['home_groupStandard_idea'] }).then(res => {
          if (res) {
            this.$router.$push({ path: "/ceppeaSolicit" })
          }
        });
      } else {
        this.$FN.LoginTips();
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>